import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";

export const getPopularAuthorsRequest = async () => {
  const response: AxiosResponse = await apiInstance.get("/popular-authors");

  return response.data;
};
